import React from "react";
import { useTranslation } from "react-i18next";
import { Sailboat, Phone, MapPin, Instagram, Mail } from "lucide-react";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A1B35] text-white pt-24 lg:pt-32 pb-10 overflow-hidden"
    >
      <div className="absolute -top-20 -right-20 w-[420px] h-[420px] rounded-full bg-[#D1BFAe]/10 blur-3xl pointer-events-none" />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative">
        <div className="border-b border-white/10 pb-16 grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <div className="overline text-[#D1BFAe] mb-6">{t("footer.eyebrow")}</div>
            <h2 className="font-serif-display text-5xl sm:text-6xl lg:text-8xl leading-[0.95]">
              {t("footer.title_pre")} <em className="italic text-[#D1BFAe]">{t("footer.title_em")}</em>
              <br />
              {t("footer.title_post")}
            </h2>
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <a href="#booking" data-testid="footer-cta" className="btn-outline">
              {t("footer.cta")}
            </a>
          </div>
        </div>

        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10 text-sm">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Sailboat className="w-5 h-5" strokeWidth={1.4} />
              <div>
                <div className="font-serif-display text-xl leading-none">Ars Vivendi</div>
                <div className="overline text-[0.6rem] text-white/60 mt-1">{t("nav.tagline")}</div>
              </div>
            </div>
            <p className="text-white/70 font-light leading-relaxed max-w-[240px]">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <div className="overline text-[#D1BFAe] mb-4">{t("footer.port")}</div>
            <div className="flex items-start gap-3 text-white/85">
              <MapPin className="w-4 h-4 mt-0.5 opacity-80" strokeWidth={1.4} />
              <div>
                {t("booking.port_value")}
              </div>
            </div>
          </div>

          <div>
            <div className="overline text-[#D1BFAe] mb-4">{t("footer.tel")}</div>
            <ul className="space-y-2 text-white/85">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 opacity-80" strokeWidth={1.4} />
                <a data-testid="footer-phone-1" href="tel:+38971326613" className="hover:text-white">
                  +389 71 326 613
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 opacity-80" strokeWidth={1.4} />
                <a data-testid="footer-phone-2" href="tel:+38970231783" className="hover:text-white">
                  +389 70 231 783
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="overline text-[#D1BFAe] mb-4">{t("footer.follow")}</div>
            <ul className="space-y-2 text-white/85">
              <li className="flex items-center gap-3">
                <Instagram className="w-4 h-4 opacity-80" strokeWidth={1.4} />
                <a href="#" className="hover:text-white">@arsvivendi.sailing</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 opacity-80" strokeWidth={1.4} />
                <a data-testid="footer-email" href="mailto:arsvivendisailingclub@gmail.com" className="hover:text-white">arsvivendisailingclub@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Ars Vivendi Sailing Club. {t("footer.rights")}</div>
          <div className="overline text-[0.6rem]">{t("footer.est")}</div>
        </div>
      </div>
    </footer>
  );
}
